import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CWTSchemaField } from '../../../../../types/custom-worksheet-v2';
import { editField } from '../../../store/slice';
import { Description } from '../../side-panel/Configurations';
import EditInput from '../EditInput';

type FieldHelperTextProps = {
    field: CWTSchemaField;
};

function FieldHelperText({ field }: FieldHelperTextProps): JSX.Element {
    const dispatch = useDispatch();
    const [helperText, setHelperText] = useState<string | undefined | null>(field.helperText);

    useEffect(() => {
        setHelperText(field.helperText);
    }, [field]);

    function handleSaveHelperText(): void {
        // If property doesn't previously have a helper text and the new helper text value is also empty
        if (!helperText?.trim() && !field.helperText) {
            setHelperText(field.helperText);
            return;
        }

        // Update helper text
        if (helperText?.trim() !== (field.helperText || '')) {
            dispatch(editField({ id: field.id, details: { helperText: helperText ? helperText.trim() : null } }));
        }
    }

    return (
        <div className="flex flex-col gap-1">
            <Description
                title="Helper Text"
                description="Provide a description to help users understand what should be provided in this field."
                isOptional
            />
            <EditInput
                autoFocus={false}
                showActionButtons={false}
                placeholder="Enter a helper text..."
                value={helperText || undefined}
                onChange={setHelperText}
                onSave={handleSaveHelperText}
                onCancel={(): void => setHelperText(field.helperText)}
            />
        </div>
    );
}

export default FieldHelperText;
